module.exports = __webpack_public_path__ + "img/3_opacity.d3183f2a.png";